import apiClient from "./apiClient";
import {AllowanceToSignResponse} from "@/types/kindergarten";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

export async function signDocument(token: string, fileId: any, cms: any) {
    try {
        const data: any = {
            cms: cms,
            fileId: fileId
        };
        return await apiClient.post<any>(
            `${BASE_URL}/api/v1/sign/document`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'blob'
            }
        ).then((response) => {
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'downloaded_file.pdf'; // Значение по умолчанию

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1];
                }
            }

            const blob = new Blob([response.data]);

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
        }).catch(async (error) => {
            // Если ошибка, обрабатываем её
            if (error.response && error.response.data) {
                const blob = error.response.data;

                try {
                    // Читаем содержимое blob как текст
                    const text = await blob.text();

                    // Пытаемся распарсить как JSON
                    const json = JSON.parse(text);
                    console.log('Parsed error message:', json.message);
                    return Promise.reject(json); // Возвращаем JSON-объект ошибки
                } catch (parseError) {
                    console.log('Could not parse blob as JSON:', parseError);
                    return Promise.reject({ message: 'Unknown error occurred', raw: await blob.text() });
                }
            }
            return Promise.reject(error);
        });
    } catch (error) {
        console.error("Error on download:", error);
        throw error;
    }
}

export async function sign1cActReconciliationDocument(token: string, fileId: any, cms: any) {
    try {
        const data: any = {
            cms: cms,
            fileId: fileId
        };
        return await apiClient.post<any>(
            `${BASE_URL}/api/v1/sign/1c-act-reconciliation/document`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: 'blob'
            }
        ).then((response) => {
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'downloaded_file.pdf'; // Значение по умолчанию

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1];
                }
            }

            const blob = new Blob([response.data]);

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
        }).catch(async (error) => {
            // Если ошибка, обрабатываем её
            if (error.response && error.response.data) {
                const blob = error.response.data;

                try {
                    // Читаем содержимое blob как текст
                    const text = await blob.text();

                    // Пытаемся распарсить как JSON
                    const json = JSON.parse(text);
                    console.log('Parsed error message:', json.message);
                    return Promise.reject(json); // Возвращаем JSON-объект ошибки
                } catch (parseError) {
                    console.log('Could not parse blob as JSON:', parseError);
                    return Promise.reject({ message: 'Unknown error occurred', raw: await blob.text() });
                }
            }
            return Promise.reject(error);
        });
    } catch (error) {
        console.error("Error on download:", error);
        throw error;
    }
}

export async function checkAllowanceToSign(lmsId: string, accountingMonth: number, accountingYear: number): Promise<AllowanceToSignResponse> {
    try {
        const response = await apiClient.post<AllowanceToSignResponse>(
            `${BASE_URL}/api/v1/sign/check/allowance/to/sign?lmsId=${lmsId}&accountingMonth=${accountingMonth}&accountingYear=${accountingYear}`
        );
        return response.data;
    } catch (error) {
        console.error("Error on getting allowance to sign:", error);
        throw error;
    }
}